// @core/api/endpoints/webhook/update_webhook_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateWebhookPolicyRequest,
  WebhookPolicyResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Update webhook policy
 * Updates an existing webhook policy.
 */
export async function UpdateWebhookPolicy(
  policy_id: string,
  data: UpdateWebhookPolicyRequest,
  options?: RequestOptions
): Promise<WebhookPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/webhook-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<WebhookPolicyResponse>(requestPath, data, requestOptions);
}
